export var SvgIconType;
(function (SvgIconType) {
    SvgIconType["Add"] = "add";
    SvgIconType["VisibleData"] = "visibleData";
    SvgIconType["InvisibleData"] = "invisibleData";
    SvgIconType["Copy"] = "copy";
    SvgIconType["Overlay"] = "overlayButton";
    SvgIconType["Indicator"] = "indicatorButton";
    SvgIconType["Tools"] = "toolsButton";
    SvgIconType["OrderEntry"] = "orderEntryButton";
    SvgIconType["MouseTrade"] = "mouseTradeButton";
    SvgIconType["ObjectManager"] = "objectManagerButton";
    SvgIconType["Checkbox"] = "checkbox";
    SvgIconType["ArrowDown"] = "arrowDown";
    SvgIconType["ArrowUp"] = "arrowUp";
    SvgIconType["ArrowRight"] = "arrowRight";
    SvgIconType["ArrowLeft"] = "arrowLeft";
    SvgIconType["Edit"] = "edit";
    SvgIconType["Close"] = "closeCrossBtn";
    SvgIconType["MenuError"] = "menuError";
    SvgIconType["UpdateNotificationArrow"] = "updateNotificationArrow";
    SvgIconType["Search"] = "search";
    SvgIconType["Beta"] = "beta";
    SvgIconType["InstrumentLookup"] = "instrumentLookup";
    SvgIconType["PositionSizing"] = "positionSizing";
    SvgIconType["TrailingStop"] = "trailingStop";
    SvgIconType["Date"] = "dateIcon";
    SvgIconType["TimeClock"] = "timeClock";
    SvgIconType["CollapseAll"] = "collapseAllIcon";
    SvgIconType["ExpandExchanges"] = "expandExchangesIcon";
    SvgIconType["ExpandTypes"] = "expandTypesIcon";
    SvgIconType["SortUp"] = "sortUp";
    SvgIconType["SortDown"] = "sortDown";
    SvgIconType["Minus"] = "minus";
    SvgIconType["Play"] = "playIcon";
    SvgIconType["Stop"] = "stopIcon";
    SvgIconType["Help"] = "help";
    SvgIconType["Ideas"] = "ideas";
    SvgIconType["Alerts"] = "alerts";
    SvgIconType["Notifications"] = "notifications";
    SvgIconType["VideoWidget"] = "videoWidget";
    SvgIconType["VideoWidgetLive"] = "videoWidgetLive";
    SvgIconType["Settings"] = "settings";
    SvgIconType["Logout"] = "logout";
    SvgIconType["QRSidebar"] = "qrSidebar";
    SvgIconType["ViewMoreHorizontal"] = "viewMoreHorizontal";
    SvgIconType["Snapshot"] = "snapshot";
    SvgIconType["DelayedData"] = "delayedData";
    SvgIconType["GoToBtn"] = "goToBtn";
    SvgIconType["ChartDrawingStyleCandles"] = "chartDrawingStyleCandles";
    SvgIconType["EditableList"] = "editableList";
    SvgIconType["ChartDrawingStyleLine"] = "chartDrawingStyleLine";
    SvgIconType["ChartDrawingStyleBar"] = "chartDrawingStyleBar";
    SvgIconType["ChartDrawingStyleDots"] = "chartDrawingStyleDots";
    SvgIconType["ChartDrawingStyleHistogram"] = "chartDrawingStyleHistogram";
    SvgIconType["ChartDrawingStyleArea"] = "chartDrawingStyleArea";
    SvgIconType["MoveSeparatorVertical"] = "moveSeparatorVertical";
    SvgIconType["ClosePositionByMkt"] = "closePositionByMkt";
    SvgIconType["CloseViaOE"] = "closeViaOE";
    SvgIconType["OrderModifyArrow"] = "orderModifyArrow";
    SvgIconType["AccountOperation"] = "accountOperation";
    SvgIconType["Cancel"] = "cancel";
    SvgIconType["InfoTool"] = "infoTool";
    SvgIconType["TabStripItemLocked"] = "tabStripItemLocked";
    SvgIconType["ViewGroup"] = "viewGroup";
    SvgIconType["Export"] = "export";
    SvgIconType["Refresh"] = "refresh";
    SvgIconType["Calculator"] = "calculator";
    SvgIconType["Chart"] = "chart";
    SvgIconType["News"] = "news";
    SvgIconType["GainersLosers"] = "gainersLosers";
    SvgIconType["HighLow"] = "highLowList";
    SvgIconType["Accept"] = "accept";
    SvgIconType["Question"] = "question";
    SvgIconType["AccountLookup"] = "accountLookup";
    SvgIconType["Grid"] = "grid";
    SvgIconType["UserGroup"] = "userGroup";
    SvgIconType["LinkedAccounts"] = "linkedAccounts";
    SvgIconType["Account"] = "account";
    SvgIconType["Statement"] = "statement";
})(SvgIconType || (SvgIconType = {}));
